// extracted by mini-css-extract-plugin
export default {"Memories":"Memories_Memories__iWgOr","searching":"Memories_searching__vXZng","parent":"Memories_parent__bN9DX","pad":"Memories_pad__je48-","pad2":"Memories_pad2__Ysaxv"};